/*
  Estrutura do eamigaconfig:
                "id_usuario",
                "nome",
                "email",
                "whatsup",
                "dt_cadastro",
                "endereco",
                "numero",
                "complemento",
                "bairro",
                "cidade",
                "uf",
                "cep",
                "cod_cidade",
                "token",
                "url_foto"
*/
export const getidusuario = () => {
    try {
        var tabconfig = JSON.parse(localStorage.getItem('eamigaconfig'));
        return tabconfig.id_usuario;
    } catch {
        return '-1';
    }
}

export const getnome = () => {
    try {
        var tabconfig = JSON.parse(localStorage.getItem('eamigaconfig'));
        return tabconfig.nome;
    } catch {
        return '';
    }
}

export const getemail = () => {
    try {
        var tabconfig = JSON.parse(localStorage.getItem('eamigaconfig'));
        return tabconfig.email;
    } catch {
        return '';
    }
}

export const getwhatsapp = () => {
    try {
        var tabconfig = JSON.parse(localStorage.getItem('eamigaconfig'));
        return tabconfig.whatsup;
    } catch {
        return '';
    }
}

export const getcodCidade = () => {
    try {
        var tabconfig = JSON.parse(localStorage.getItem('eamigaconfig'));
        return Number(tabconfig.cod_cidade)||0;
    } catch (e) {
        return 0;
    }
}

export const gettoken = () => {
    try {
        var tabconfig = JSON.parse(localStorage.getItem('eamigaconfig'));
        return tabconfig.token.length > 0;
    } catch {
        return false;
    }
}

export const gettokentoken = () => {
    try {
        var tabconfig = JSON.parse(localStorage.getItem('eamigaconfig'));
        return tabconfig.token
    } catch {
        return 'invalido';
    }
}

export const getparceiro = () => {
    try {
        var tabconfig = JSON.parse(localStorage.getItem('eamigaconfig'));
        return tabconfig.parceiro;
    } catch {
        return false;
    }
}

export const getadmin = () => {
    try {
        var tabconfig = JSON.parse(localStorage.getItem('eamigaconfig'));
        return tabconfig.admin ?? false;
    } catch {
        return false;
    }
}

export const getenderecoAll = () => {
    try {
        var tabconfig = JSON.parse(localStorage.getItem('eamigaconfig'));
        return `${tabconfig.endereco},${tabconfig.numero} - ${tabconfig.bairro} - ${tabconfig.cidade} - ${tabconfig.uf} - ${tabconfig.cep}`;
    } catch {
        return '';
    }
}

export const getestabelecimentos = (index) => {
    try {
        var tabconfig = JSON.parse(localStorage.getItem('eamigaconfig'));
        return tabconfig.estabelecimentos[index];
    } catch {
        return 0;
    }
}

export const getfotoperfil = () => {
    try {
        var tabconfig = JSON.parse(localStorage.getItem('eamigaconfig'));
        return tabconfig.url_foto || null;
    } catch {
        return null;
    }
}